export default "__VITE_ASSET__DJa37Kt___"